const userLabelTypeName = "UserLabel";
const userLabelGroupTypeName = "UserLabelGroup";
const userLabelViewModelTypeName = "UserLabelViewModel";
const userLabelGroupViewModelTypeName = "UserLabelGroupViewModel";
export {
  userLabelGroupTypeName,
  userLabelGroupViewModelTypeName,
  userLabelTypeName,
  userLabelViewModelTypeName
};
//# sourceMappingURL=constants.js.map
